import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from '@angular/router';
import {MotorQuoteDTO} from '../models/MotorQuoteDTO.interfaces';
import {inject} from '@angular/core';
import {RouterDataService} from '../services/router-data/router-data.service';
import {ThankYouPages} from '../enums/thank-you-pages.enum';

export const RouterDataResolver: ResolveFn<MotorQuoteDTO> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const dataStorageService = inject(RouterDataService);
  return dataStorageService.getMotorQuoteObject();
};
export const RouterThankYouFlowResolver: ResolveFn<ThankYouPages | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const dataStorageService = inject(RouterDataService);
  return dataStorageService.getThankYouFlow();
};
